import { useAuth0 } from '@auth0/auth0-react';
import { subscriptionService, SubscriptionInfo } from '../services/subscription.service';

export interface UseSubscriptionGuardReturn {
  hasAccess: boolean;
  subscriptionInfo: SubscriptionInfo | null;
  isLoading: boolean;
}

/**
 * Custom hook to check subscription access and provide subscription info
 */
export const useSubscriptionGuard = (): UseSubscriptionGuardReturn => {
  const { user, isLoading } = useAuth0();

  if (isLoading || !user) {
    return {
      hasAccess: false,
      subscriptionInfo: null,
      isLoading: true
    };
  }

  const subscriptionInfo = subscriptionService.getSubscriptionInfo(user);
  const hasAccess = subscriptionService.hasAccess(user);

  return {
    hasAccess,
    subscriptionInfo,
    isLoading: false
  };
};
